import SUB_MUTATIONS from "./sub/mutations";
export default {
  SET_PAID_COIN_FROM_PERIOD(state, { coin, paid }) {
    state.customer.paid[coin] = paid;
  },
  SET_COIN_BALANCE(state, { coin, amount }) {
    state.customer.balance[coin] = {
      ...amount,
      coin,
    };
  },
  SET_SETTINGS(state, settings) {
    state.customer.settings = settings;
  },
  SET_ADDRESSES(state, addresses) {
    const parsedAddresses = {};

    addresses.forEach((address) => (parsedAddresses[address.coin] = address));

    state.customer.addresses = parsedAddresses;
  },

  SET_ACCOUNTS(state, identifier) {
    state.customer.identifier = {
      ...identifier,
    };
  },
  ...SUB_MUTATIONS,
};
